var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c("div", [
        _c("div", { staticClass: "columns is-gapless" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showfilter,
                  expression: "showfilter",
                },
              ],
              staticClass: "column is-narrow",
            },
            [
              _c("error-log-list-side-menu", {
                on: { filter: _vm.loadErrorLogDetail, reset: _vm.resetList },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("error-log-detail", {
                model: {
                  value: _vm.selectedErrorLog,
                  callback: function ($$v) {
                    _vm.selectedErrorLog = $$v
                  },
                  expression: "selectedErrorLog",
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }